import React from "react";
import { ReactComponent as RowIcon } from "../../../assets/icons/warehouse/row.svg";
import styles from "./styles.module.scss";

interface Props {
  name: string;
  needCount: number;
  count: number;
  isActive: boolean;
  capacity?: string;
  onClick: (search: string) => void;
}

const ResourceCountButton: React.FC<Props> = (props) => {
  return (
    <div className={styles.block}>
      <div className={styles.container}>
        <div
          className={`${styles.viewContainer} ${
            props.count >= props.needCount ? styles.success : ""
          }`}
        >
          <span className={styles.viewText}>
            {props.name}
            {props.capacity ? `, ${props.capacity}` : ""}
          </span>
          <div className={styles.status}>
            <span>{`${props.count} з ${props.needCount}`}</span>
          </div>
        </div>
        <button
          className={styles.buttonB}
          type="button"
          onClick={() => props.onClick(props.name)}
        >
          <RowIcon />
        </button>
      </div>
    </div>
  );
};

export default ResourceCountButton;
